import { Component, ViewChild } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { AddChildProfileComponent } from '../../../lib/add-child-profile/add-child-profile.component'

const exampleHtml = `
<se-po-add-child-profile #childProfile></se-po-add-child-profile>
<div class="form-value">
  <code>
    {{ childProfile.value | json }}
  </code>
</div>
`

const exampleTypescript = `
import { Component, ViewChild } from '@angular/core'
import { AddChildProfileComponent } from '@se-po/shared-ui-add-child-profile'

export class AddChildProfileDocsComponent {
  @ViewChild('childProfile') public childProfile: AddChildProfileComponent
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-add-child-profile-example',
  template,
  styleUrls: ['../add-child-profile-docs.component.scss'],
  standalone: false,
})
export class AddChildProfileExampleComponent extends SeFeDocsExampleComponent {
  @ViewChild('childProfile') public childProfile: AddChildProfileComponent

  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
}
